module.exports = __webpack_public_path__ + "img/Logo.d1d9be56.svg";